import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function CreateSupplierLineItemPage() {
  const { supplierId } = useParams<{ supplierId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/cost-center/internal-line-items/create?supplierId=${supplierId}`, { replace: true });
  }, [supplierId, navigate]);

  return null;
}
